import { ITariff } from "@/models/tariff/tariff.types"
import { HasuraTariffParser } from "@/models/tariff/tariff.parser"
import { QueryResult } from "@/api/utils/types"
import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"

export interface ITariffService {
  getForGsp(gsp: string): QueryResult<ITariff[]>
}

class TariffServiceClass implements ITariffService {
  getForGsp(gsp: string): QueryResult<ITariff[]> {
    return useQuery({
      ...HasuraQueries.tariffs.forGsp(gsp),
      placeholderData: [],
      useRawResponse: true,
      parserFn: (rawData) =>
        rawData.current_future_product_details.map((raw) =>
          HasuraTariffParser.toDomain(raw),
        ),
    })
  }
}

export const TariffService = new TariffServiceClass()
